import { render, staticRenderFns } from "./ListPointers.vue?vue&type=template&id=5fed179a&scoped=true&"
import script from "./ListPointers.vue?vue&type=script&lang=js&"
export * from "./ListPointers.vue?vue&type=script&lang=js&"
import style0 from "./ListPointers.vue?vue&type=style&index=0&id=5fed179a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fed179a",
  null
  
)

export default component.exports